import focusTrapModal from "../../_utils/focus-trap-modal";

export default class HeaderComponent extends HTMLElement {
    private _primaryNavContainer: HTMLElement;
    private _menuNavContainer: HTMLElement;
    private _navBackdrop: HTMLElement;
    private _openMenuButton: HTMLButtonElement;
    private _closeMenuButton: HTMLButtonElement;
    private _currentPageYOffset: number = 0;
    private _carouselHero: HTMLElement;
    private _utilityNav: HTMLElement;
    private _mainContent: HTMLElement;

    constructor() {
        super();
        this._primaryNavContainer = this.querySelector('nav.-primary.main-nav');
        this._menuNavContainer = this.querySelector('nav.-menu');
        this._navBackdrop = this.querySelector('.nav-backdrop');
        this._openMenuButton = this.querySelector('button.open-mobile-menu');
        this._closeMenuButton = this.querySelector('button.close-mobile-menu');
        this._carouselHero = document.querySelector('carousel-hero-slides-container');
        this._utilityNav = document.querySelector('nav.utility-nav');
        this._mainContent = document.querySelector('main#main');
    }

    private handleResize = () => {
        this.classList.remove('is-mobile-menu-visible');
        this.resetNavCollisionClasses();
        this.verifyNavLinksAreNotColliding();
    }

    private verifyNavLinksAreNotColliding = () => {
        const isNavContainerVisible = this._primaryNavContainer.offsetWidth > 0 && this._primaryNavContainer.offsetHeight > 0;
        if (!isNavContainerVisible) {
            this.classList.add('is-mobile-menu-visible');
            return;
        }

        const primaryNavSpacing = 16 * 2;
        const primaryNavWidth = this._primaryNavContainer.offsetWidth - primaryNavSpacing;
        const primaryNavChildren = this._primaryNavContainer.children;

        let primaryNavChildrenWidth = 0;
        for (let i = 0; i < primaryNavChildren.length; i++) {
            const element = primaryNavChildren[i] as HTMLElement;
            primaryNavChildrenWidth += element.offsetWidth;
        }

        if (primaryNavChildrenWidth >= primaryNavWidth && window.innerWidth >= 300) {
            this.fixCollidingNavContainerLinks();
            this.verifyNavLinksAreNotColliding(); // recursively call to fix all colliding links
        }
    }

    private fixCollidingNavContainerLinks = () => {
        const navContainerNavLinks = Array.from(
            this._primaryNavContainer.querySelectorAll('.nav-item:not(.-colliding)')
        ).reverse() as Array<HTMLElement>;
        const mobileNavContainerNavLinks = Array.from(
            this._menuNavContainer.querySelectorAll('.nav-item:not(.-primary-colliding)')
        ).reverse() as Array<HTMLElement>;
        let foundCollidingLink: boolean = false;

        if (navContainerNavLinks.length) {
            navContainerNavLinks[navContainerNavLinks.length - 1].classList.add('-colliding');
            foundCollidingLink = true;
        }

        if (mobileNavContainerNavLinks.length) {
            mobileNavContainerNavLinks[mobileNavContainerNavLinks.length - 1].classList.add('-primary-colliding');
            foundCollidingLink = true;
        }

        if (foundCollidingLink) {
            this.classList.add('is-mobile-menu-visible');
        }
    }

    private resetNavCollisionClasses = () => {
        const colidingNavLinks = Array.from(this.querySelectorAll('.nav-item.-colliding, .nav-item.-primary-colliding')) as Array<HTMLElement>;
        for (let i = 0; i < colidingNavLinks.length; i++) {
            colidingNavLinks[i].classList.remove('-colliding', '-primary-colliding');
        }
    }

    private openMenu = () => {
        this._menuNavContainer.classList.add('is-open');
        this._menuNavContainer.setAttribute('aria-expanded', 'true');
        this._navBackdrop.addEventListener('click', this.closeMenu);
        focusTrapModal(this._menuNavContainer);
    }

    private closeMenu = () => {
        this._menuNavContainer.classList.remove('is-open');
        this._menuNavContainer.setAttribute('aria-expanded', 'false');
        this._navBackdrop.removeEventListener('click', this.closeMenu);
        this._openMenuButton.focus();
    }

    private handleEscMobileClose = (e: KeyboardEvent) => {
        let isEscPressed = e.key === 'Escape';
        if (!isEscPressed) {
            return;
        }
        if (isEscPressed) {
            this.closeMenu();
        }
    }
    private checkHeroHeight = () => {
        if(!this._carouselHero) return;

        if(this._currentPageYOffset > this._carouselHero.offsetHeight) {
                this._primaryNavContainer.classList.add('hero-hidden');
            }
        else {
                this._primaryNavContainer.classList.remove('hero-hidden');
            }

    }
    private handleScroll = (e: Event) => {
        const { pageYOffset } = window;

        this.checkHeroHeight();

        if (this._currentPageYOffset > pageYOffset) {
            if (this.classList.contains('nav-hidden')) this.classList.remove('nav-hidden');
        }
        else if (pageYOffset > 200) {
            if (!this.classList.contains('nav-hidden')) this.classList.add('nav-hidden');
        }

        this._currentPageYOffset = pageYOffset;
    }

    connectedCallback() {
        this.verifyNavLinksAreNotColliding();
        this.classList.remove('is-loading');
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll, true);
        this._openMenuButton.addEventListener('click', this.openMenu);
        this._closeMenuButton.addEventListener('click', this.closeMenu);
        this._menuNavContainer.addEventListener('keydown', this.handleEscMobileClose);
        if(!this._carouselHero) {
            this._mainContent.style.paddingTop = `${this.offsetHeight - 2}px`;
            this._primaryNavContainer.classList.add('hero-hidden');
        }
    }
}
